import { getProtocolInsightsPermissions } from '@utils-clean/protocol-insights-access';
import { RiskIQAccess } from 'types/graphql-global-types';

// RiskIQ comments follow the Trial.OS access level (ADO 90806): every level but no access can see them, and only
// read/write-comments or read/write can write them, while the selected review is still open.
export const getRiskIqCommentsAccess = (
    access: RiskIQAccess | null | undefined,
    isFinished: boolean | undefined,
): { showComments: boolean; writeEnabled: boolean } => {
    const { canView, canWriteComments } = getProtocolInsightsPermissions(access);
    return { showComments: canView, writeEnabled: canWriteComments && isFinished === false };
};
